import React, { useState } from "react";

export default function HotarariCAPage() {

  // 🔹 lista fișierelor HCA (ultimele prime)

  const files = [

    "HCA 20.07.2026.PDF",
    "HCA 29.06.2026.PDF",
    "HCA 29.05.2026.PDF",
    "HCA 19.05.2026.PDF",
    "HCA 15.05.2026.PDF",
    "HCA 04.05.2026.PDF",
    "HCA 30.04.2026.PDF",
    "HCA 23.04.2026.PDF",
    "HCA 05.04.2026.PDF",
    "HCA 25.03.2026.PDF",
    "HCA 13.03.2026.PDF",
    "HCA 02.03.2026.PDF",
    "HCA 27.02.2026.PDF",
    "HCA 13.02.2026.PDF",
    "HCA 03.02.2026.PDF",
    "HCA 02.02.2026.PDF",
    "HCA 23.01.2026.PDF",
    "HCA 20.01.2026.PDF",
    "HCA 13.01.2026.PDF",

    "HCA 19.12.2025.pdf",
    "HCA 20.11.2025.pdf",
    "HCA 31.10.2025.pdf",
    "HCA 24.10.2025.pdf",
    "HCA 30.09.2025.pdf",
    "HCA 10.09.2025.PDF",
    "HCA 01.09.2025.PDF",
    "HCA 20.08.2025.PDF",
    "HCA 13.08.2025.PDF",
    "HCA 05.08.2025.PDF",
    "HCA 30.06.2025.PDF",
    "HCA 17.06.2025.PDF",
    "HCA 21.05.2025.PDF",
    "HCA 30.04.2025.PDF",
    "HCA 24.04.2025.PDF",
    "HCA 14.04.2025.PDF",
    "HCA 11.04.2025.PDF",
    "HCA 07.04.2025.PDF",
    "HCA 27.03.2025.PDF",
    "HCA 14.03.2025.PDF",
    "HCA 28.02.2025.PDF",
    "HCA 17.02.2025.PDF",
    "HCA 31.01.2025.PDF",

  ];
  
  const [visibleCount, setVisibleCount] = useState(5);

  const handleShowMore = () => setVisibleCount((prev) => prev + 5);
  const handleShowLess = () => setVisibleCount(5);

  return (
    <div className="bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <h2 className="text-xl font-bold mt-8 mb-4">
          Hotărârile Consiliului de Administrație
        </h2>

        <ul>
          {files.slice(0, visibleCount).map((file) => (
            <li key={file} className="mb-3 flex items-center flex-wrap">
              <span className="font-bold text-lg mr-3">
                {file.replace(".PDF", "")}
              </span>
              <a
                href={`/documente/hotarariCA/${encodeURIComponent(file)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline"
              >
                Deschide
              </a>
            </li>
          ))}
        </ul>

        <div className="mt-6 flex space-x-4">
          {visibleCount < files.length && (
            <button
              onClick={handleShowMore}
              className="px-4 py-2 rounded transition"
              style={{
                backgroundColor: "rgba(170,190,107,0.8)",
                color: "black",
              }}
              onMouseEnter={(e) =>
                (e.target.style.backgroundColor = "rgba(170,190,107,1)")
              }
              onMouseLeave={(e) =>
                (e.target.style.backgroundColor = "rgba(170,190,107,0.8)")
              }
            >
              Arată mai multe
            </button>
          )}

          {visibleCount > 5 && (
            <button
              onClick={handleShowLess}
              className="px-4 py-2 rounded transition"
              style={{
                backgroundColor: "red",
                color: "white",
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "darkred")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "red")}
            >
              Ascunde
            </button>
          )}
        </div>
      </main>
    </div>
  );
}
